import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { RoutesPaths } from "../../Router/constant";
import { useDispatch, useSelector } from "react-redux";
import { getNotificationType } from "../../Action/notification";

export default function Notification() {
  //   const { questionsList, count } = useSelector((state) => state.question);
  const { notificaionList, count } = useSelector((state) => state.notification);

  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
  const totalPages = Math.ceil(count / recordsPerPage);

  useEffect(() => {
    dispatch(getNotificationType(currentPage, recordsPerPage));
    console.log("notificaionList", notificaionList);
  }, [dispatch, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const generatePageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbers = 5; // Adjust this to show more/less page numbers

    if (totalPages <= maxPageNumbers) {
      for (let i = 1; i <= totalPages; i++) {
        // Start from 1
        pageNumbers.push(i);
      }
    } else {
      const halfPageNumbers = Math.floor(maxPageNumbers / 2);
      let startPage = Math.max(currentPage - halfPageNumbers + 1, 1); // Adjust index to start from 1
      let endPage = Math.min(startPage + maxPageNumbers - 1, totalPages);

      if (currentPage > totalPages - halfPageNumbers) {
        startPage = totalPages - maxPageNumbers + 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
    }

    return pageNumbers;
  };

  return (
    <>
      <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
        <div className="d-flex flex-column flex-column-fluid">
          <div id="kt_app_toolbar" className="app-toolbar pt-7 pt-lg-10">
            <div
              id="kt_app_toolbar_container"
              className="app-container container-fluid d-flex align-items-stretch"
            >
              <div className="app-toolbar-wrapper d-flex flex-stack flex-wrap gap-4 w-100">
                <div className="page-title d-flex flex-column justify-content-center gap-1 me-3">
                  <h1 className="page-heading d-flex flex-column justify-content-center text-gray-900 fw-bold fs-3 m-0">
                    Notification Type
                  </h1>
                  <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0">
                    <li className="breadcrumb-item text-muted">
                      Over {count} Question
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div id="kt_app_content" className="app-content flex-column-fluid">
            <div
              id="kt_app_content_container"
              className="app-container container-fluid"
            >
              <div className="card">
                <div className="card-header border-0 pt-6 customCategoryHeader">
                  <div className="card-title">
                    <div className="d-flex align-items-center position-relative my-1">
                      {/* <i className="ki-outline ki-magnifier fs-3 position-absolute ms-5" />
                      <input
                        type="text"
                        data-kt-user-table-filter="search"
                        className="form-control form-control-solid w-250px ps-13"
                        placeholder="Search banner"
                      /> */}
                    </div>
                  </div>

                  <NavLink
                    to={{
                      pathname: RoutesPaths.QUESTIONS,
                    }}
                    className="btn btn-flex btn-center btn-sm"
                  >
                    <div className="">
                      <button
                        id="kt_account_deactivate_account_submit"
                        type="submit"
                        className="btn btn-success fw-semibold colorGreen"
                      >
                        Add Question
                      </button>
                    </div>
                  </NavLink>
                </div>
                <div className="card-body py-4">
                  <table
                    className="table align-middle table-row-dashed fs-6 gy-5"
                    id="kt_table_users"
                  >
                    <thead>
                      <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                        {/* <th className="min-w-125px">Banner Image</th> */}
                        <th className="min-w-125px">Title</th>
                        <th className="min-w-125px">Description</th>
                        <th className="min-w-200px">NotificationType</th>
                        <th className="min-w-200px">Active</th>
                        <th className="min-w-200px">Enable</th>
                        <th className="text-center min-w-100px">Actions</th>
                      </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold">
                      {notificaionList?.length > 0 ? (
                        notificaionList.map((item, index) => {
                          return (
                            <tr key={index}>
                              {/* <td>
                                <img
                                  src={backendUrl + banner.image}
                                  alt=""
                                  className="categoryImage"
                                  onError={handleError} // handle the error event
                                />
                              </td> */}
                              <td>
                                <div className="d-flex flex-column">
                                  <span className="text-gray-800 mb-1">
                                    {item?.title}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column">
                                  <span className="text-gray-800 mb-1">
                                    {item?.description}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column">
                                  <span className="text-gray-800 mb-1">
                                    {JSON.stringify(item?.notificationType)}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column">
                                  <span className="text-gray-800 mb-1">
                                    {JSON.stringify(item?.isActive)}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column">
                                  <span className="text-gray-800 mb-1">
                                    {JSON.stringify(item?.isEnable)}
                                  </span>
                                </div>
                              </td>
                              <td className="td-last">
                                {/* <NavLink
                                  // to={RoutesPaths.BANNER}
                                  // state={{ banner: banner }}
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm me-2"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  View
                                </NavLink> */}

                                <NavLink
                                  to={RoutesPaths.QUESTIONS}
                                  state={{ question: item }}
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  Edit
                                </NavLink>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No question available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <div className="d-flex justify-content-center">
                    <button
                      className="btn btn-primary"
                      onClick={() => handlePageChange(1)} // Go to page 1 when clicking the first arrow
                      disabled={currentPage === 1}
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-double-left"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M11.354 1.646a.5.5 0 0 1 0 .708L6.707 7l4.647 4.646a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0zM7.354 1.646a.5.5 0 0 1 0 .708L2.707 7l4.647 4.646a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0z"
                        />
                      </svg>
                    </button>
                    <button
                      className="btn btn-primary mx-2"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-left"
                      >
                        <path
                          fillRule="evenodd"
                          d="M11.354 1.646a.5.5 0 0 1 0 .708L6.707 7l4.647 4.646a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0z"
                        />
                      </svg>
                    </button>

                    {generatePageNumbers().map((page, index) => (
                      <button
                        key={index}
                        className={`btn btn-light btn-active-light-primary mx-1 ${
                          page === currentPage ? "active" : ""
                        }`} // Adjust for 1-based display
                        onClick={() => handlePageChange(page - 1)} // Subtract 1 to set correct zero-based page
                      >
                        {page}
                      </button>
                    ))}

                    <button
                      className="btn btn-primary mx-2"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-right"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4.646 1.646a.5.5 0 0 1 .708 0l5 5a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708-.708L9.293 7 4.646 2.354a.5.5 0 0 1 0-.708z"
                        />
                      </svg>
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => handlePageChange(totalPages - 1)} // Go to last page
                      disabled={currentPage === totalPages}
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-double-right"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4.646 1.646a.5.5 0 0 1 .708 0l5 5a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708-.708L9.293 7 4.646 2.354a.5.5 0 0 1 0-.708zm4 0a.5.5 0 0 1 .708 0l5 5a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708-.708L13.293 7 8.646 2.354a.5.5 0 0 1 0-.708z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
